export const ACTION_CREATE = "CREATE";
export const ACTION_DELETE = "DELETE";
export const ACTION_EDIT = "EDIT";
export const ACTION_ENABLE = "ENABLE";
export const ACTION_RESET_PASS = "RESET_PASSWORD";